<template>
  <div class="viewport viewport-with-top-nav viewport-compact">
    <TopNav></TopNav>
    <h4 class="my-1">{{ $t('ContractSendPage.title') }}</h4>
    <p v-if="showEmailForm">{{ $t('ContractSendPage.text') }}</p>
    <EmailAgreementForm :is-downloadable="isDownloadable"
                        :on-download="download"
                        :email-endpoint="`/api/loans/${reference}/email/${type}`"/>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import EmailAgreementForm from '@shared/components/EmailAgreementForm'
import i18n from '@shared/module/i18n'
import settings from '@shared/settings'

export default {
  name: 'ContractSendPage',
  components: {
    EmailAgreementForm,
    TopNav
  },
  props: ['isDownloadable', 'isSigned'],
  data() {
    return {
      errors: [],
      email: store.state.currentUser.email || '',
      emailSending: false,
      reference: this.$route.params.reference
    }
  },
  computed: {
    showEmailForm() {
      if (!this.$configuration.newCoreEnabled) {
        return true
      }
      return !!this.email
    },
    type() {
      return this.isSigned ? 'signed_contract' : 'contract'
    }
  },
  methods: {
    download() {
      return this.$http
          .get(`/api/loans/${this.reference}/contract/downloading-hash`)
          .then(response => {
            const hash = response.data.hash
            const params = `hash=${hash}&locale=${i18n.locale}`
            window.location = `${settings.backendUrl()}/api/loans/${this.reference}/contract/download?${params}`
          })
    }
  }
}
</script>
